import ApiService from "../api-service";
import { BASE_URL } from "../../../config";
import {
	FETCH_RUMMY_PARTNER_TRANSACTION_HISTORY,
	FETCH_RUMMY_PARTNER_RETAILER_TRANSACTION_HISTORY,
	PAY_RUMMY_USER,
	RESET_JEET11_SEARCHED_USER,
	SHOW_ALERT,
	TOGGLE_APP_MODE
} from "../action-types";
import {
	fetchRummyTransactionHistorySuccess,
	payRummyUserSuccess,
	rummyTransactionHistorySuccess,
	toggleAppMode
} from "../mutation-types";
import { DEFAULT_ERROR_MESSAGE, END, TOP } from "../config";
import _get from "lodash/get";
import { _getDateTimeFormat } from "../../utils";

const state = {
	isRummyOptionSelected: false,
	rummyPartnerTransactionHistory: {
		list: [],
		offset: undefined
	},
	rummyPartnerRetailerTransactionHistory: {
		list: [],
		offset: undefined
	},
	rummyPartnerDetails: {}
};

const getters = {
	isRummyOptionSelected: state => {
		return state.isRummyOptionSelected;
	}
};

const actions = {
	[TOGGLE_APP_MODE.action]: ({ commit }, payload) => {
		commit(toggleAppMode, {
			reqPayload: payload
		});
	},
	[FETCH_RUMMY_PARTNER_TRANSACTION_HISTORY.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getGamePaymentHistory";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(payload.type === END
					? {
							offset: _get(
								rootState,
								"rummy.rummyPartnerTransactionHistory.offset"
							)
					  }
					: {}),
				...(payload.userId
					? {
							u: payload.userId
					  }
					: {}),
				...(payload.commission ? { commission: true } : {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(rummyTransactionHistorySuccess, {
						...data.response,
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[PAY_RUMMY_USER.action]: ({ commit, dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/gameTransferMoney";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(payRummyUserSuccess, data.response);
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: data.response.msg },
						{ root: true }
					);
					dispatch(
						RESET_JEET11_SEARCHED_USER.dispatch,
						{},
						{
							root: true
						}
					);
					// if (
					// 	rootState.auth.storeType === JEET_11_CAPTAIN &&
					// 	rootState.auth.TEAM_TYPE === "retail"
					// ) {
					// 	dispatch(
					// 		FETCH_CAPTAIN_TARGETS.dispatch,
					// 		{},
					// 		{ root: true }
					// 	);
					// }
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg.message;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.log(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[FETCH_RUMMY_PARTNER_RETAILER_TRANSACTION_HISTORY.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getGamePaymentHistory";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				u: payload.retailerId,
				...(payload.type === END
					? {
							offset: _get(
								rootState,
								"rummy.rummyPartnerRetailerTransactionHistory.offset"
							)
					  }
					: {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchRummyTransactionHistorySuccess, {
						...data.response,
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	}
};

const mutations = {
	[toggleAppMode](state, { reqPayload }) {
		state.isRummyOptionSelected = reqPayload;
	},
	[rummyTransactionHistorySuccess](
		state,
		{
			userTransactionHistory: transactions,
			offsetValue: offset = null,
			type = TOP
		}
	) {
		transactions = transactions.map(el => {
			return {
				...el,
				paymentType: el.paymentType === "C" ? "credit" : "debit",
				teamName: el.user ? el.user.teamName : el.userId,
				createdOn: _getDateTimeFormat(el.createdOn)
			};
		});
		if (type === TOP) {
			state.rummyPartnerTransactionHistory = {
				list: [...transactions],
				offset
			};
		} else if (type === END) {
			state.rummyPartnerTransactionHistory = {
				list: [
					...state.rummyPartnerTransactionHistory.list,
					...transactions
				],
				offset
			};
		}
	},
	[payRummyUserSuccess](
		state,
		{ retailerAmount, totalCommissionEarned, referralEarning }
	) {
		state.rummyPartnerDetails = {
			...state.rummyPartnerDetails,
			walletBalance: retailerAmount,
			totalCommissionEarned,
			referralEarning
		};
	},
	[fetchRummyTransactionHistorySuccess](
		state,
		{ userTransactionHistory: transactions, offset, type = TOP }
	) {
		transactions = transactions.map(el => {
			return {
				...el,
				paymentType: el.paymentType === "C" ? "credit" : "debit",
				teamName: el.user ? el.user.teamName : el.userId,
				createdOn: _getDateTimeFormat(el.createdOn)
			};
		});
		if (type === TOP) {
			state.rummyPartnerRetailerTransactionHistory = {
				list: [...transactions],
				offset
			};
		} else if (type === END) {
			state.rummyPartnerRetailerTransactionHistory = {
				list: [
					...state.jeet11PartnerRetailerTransactionHistory.list,
					...transactions
				],
				offset
			};
		}
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};
